export default __webpack_public_path__ + "static/media/news71.8e224964.jpg";